export default __webpack_public_path__ + "static/media/shadow.9ecefdc8.svg";